/**
 * Formatea una fecha a DD-MM-YYYY.
 * Acepta: 'YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss...', Date, o timestamp.
 * Retorna string vacío para valores inválidos/nulos.
 */
export function formatDDMMYYYY(input) {
  if (!input) return '';
  const s = String(input).trim();
  // ISO date-only 'YYYY-MM-DD'
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[3]}-${isoMatch[2]}-${isoMatch[1]}`;
  }
  // Try Date parse fallback
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

/** DD-MM-YYYY HH:mm a partir de un ISO (hora local tal como viene del backend). */
export function formatDDMMYYYYHHmm(input) {
  const m = String(input || '').match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  return m ? `${m[3]}-${m[2]}-${m[1]} ${m[4]}:${m[5]}` : formatDDMMYYYY(input);
}
